var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProcessingScreen',{attrs:{"progress":_vm.progress,"total":_vm.total,"desc":_vm.failed > 0 ? _vm.importFailed : '',"title":_vm.total === _vm.progress
			? _vm.importedHeader
			: _vm.importingHeader}}),_vm._v(" "),_c('div',{staticClass:"close__button"},[(_vm.total === _vm.progress)?_c('Button',{staticClass:"primary",on:{"click":_vm.onClose}},[_vm._v("\n\t\t\t"+_vm._s(_vm.t('contacts', 'Close'))+"\n\t\t")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }